// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__37k7j","footer":"ModalCreateQualiphyProcedure_footer__qzPEF","additionData":"ModalCreateQualiphyProcedure_additionData__12ucd"};